import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button, Stack, Typography } from '@mui/material'
import Box from '@mui/material/Box'

import { ROUTES } from 'routes/routes'

interface ScanClaimProcessProps {
  handleClose?: () => void
}

/**
 * VERA-839: previously a static, unwired mockup (a `useForm()` with no
 * submit handler and hardcoded "Sign In" / "Create Account" buttons that did
 * nothing). Replaced with real navigation to the live auth surfaces —
 * `/sign-in` (existing sign-in) and `/create-account` (VERA-843
 * account-email path) / `/claim` doesn't apply here directly since this
 * component isn't scoped to one certificate; it's the generic "sign in to
 * continue" prompt rendered from `CertificatePage`'s `!claimedProduct` drawer.
 *
 * NOTE: `CertificatePage`'s `claimedProduct` toggle (index.tsx) starts `true`
 * and its drawer close-handler calls `setClaimedProduct(false)`, which flips
 * the `!claimedProduct` condition back to `true` — i.e. closing the drawer
 * re-opens it. That's a pre-existing bug in the drawer's own state machine,
 * out of scope for this batch (flagged, not fixed, here).
 */
export const ScanClaimProcess = ({ handleClose }: ScanClaimProcessProps) => {
  const navigate = useNavigate()

  return (
    <Box>
      <Typography mb="24px" variant="body1">
        Sign in or create an account to continue.
      </Typography>
      <Stack spacing={3}>
        <Button
          fullWidth
          variant="contained"
          onClick={() => {
            handleClose?.()
            navigate(ROUTES.SIGN_IN)
          }}
        >
          Sign In
        </Button>
        <Button
          fullWidth
          variant="outlined"
          onClick={() => {
            handleClose?.()
            navigate(ROUTES.CREATE_ACCOUNT)
          }}
        >
          Create Account
        </Button>
      </Stack>
    </Box>
  )
}
